"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhaseTimer = PhaseTimer;
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const sessionContext_1 = require("~/game/sessionContext");
const plugins_1 = require("~/plugins");
const players_1 = require("~/store/game/players");
const models_1 = require("@creature-chess/models");
const countdown_1 = require("../ui/countdown");
const renderPhaseInfoCountdown = (secondsRemaining) => (React.createElement("span", null,
    "(",
    secondsRemaining,
    ")"));
function PhaseTimer() {
    var _a;
    const settings = (0, sessionContext_1.useGamemodeSettings)();
    const phase = (0, react_redux_1.useSelector)((state) => state.game.roundInfo.phase);
    const phaseStartedAtSeconds = (0, react_redux_1.useSelector)((state) => state.game.roundInfo.phaseStartedAtSeconds);
    const gameOver = ((_a = (0, players_1.useLocalPlayer)()) === null || _a === void 0 ? void 0 : _a.health) === 0;
    const phaseLengthMs = {
        [models_1.GamePhase.PREPARING]: settings.preparingPhaseLengthMs,
        [models_1.GamePhase.READY]: settings.readyPhaseLengthMs,
        [models_1.GamePhase.PLAYING]: settings.playingPhaseMaxLengthMs,
    };
    const phaseDurationSeconds = phase === null || !phaseStartedAtSeconds
        ? null
        : phaseLengthMs[phase] / 1000;
    const phaseEndTimeSeconds = phase === null || !phaseStartedAtSeconds || phaseDurationSeconds === null
        ? null
        : phaseDurationSeconds + phaseStartedAtSeconds;
    let content = null;
    if (gameOver) {
        content = React.createElement("span", null, "GAME OVER");
    }
    else if (phaseEndTimeSeconds !== null) {
        content = (React.createElement("span", null,
            React.createElement(countdown_1.Countdown, { countdownToSeconds: phaseEndTimeSeconds, render: renderPhaseInfoCountdown })));
    }
    return (React.createElement(plugins_1.Region, { cls: "phase-timer", ctx: { phaseEndTimeSeconds, phaseDurationSeconds, gameOver } }, content));
}
